import React from 'react'

/**
 * Quote component for displaying styled blockquotes
 * @param {Object} props - Component props
 * @param {Object} props.data - Data containing title and body
 * @returns {JSX.Element}
 */
const Quote = ({ data }) => {
    if (!data) {
        return null
    }

    const { title, body } = data

    return (
        <div className="blog-quote">
            {title && (
                <blockquote className="quote-title">
                    <p>{title}</p>
                </blockquote>
            )}
            {body && (
                <blockquote className="quote-body">
                    {body}
                </blockquote>
            )}
        </div>
    )
}

export default Quote
